import "../books.css";

const one = (
  <div>
    <h2 id="outside-the-orphanage">Outside the Orphanage</h2>
    <p>
      Myles had spent nearly every waking hour for the past three days staring
      at this wall. The plain white wallpaper stared relentlessly back at him,
      refusing to betray any of the secrets it held in the six months since he
      had begun to study it in earnest.
    </p>
    <p>
      Sometimes, after long mind numbing hours sitting here, he thought he could
      see, or maybe feel, wisps if something inside it but whenever he focused
      on it the sensation disappeared.
    </p>
    <p>
      Now he was running out of time; he was due to graduate on the
      Caretaker&#39;s next visit. He was supposed to be in bed right now and the
      other kids would notice his absence. They wouldn&#39;t care though, only
      Livian ever had and she had graduated almost a year ago.
    </p>
    <p>
      Myles&#39;s breakthrough with the wall seemed to come suddenly. He was
      running his homemade wand, which had proved to work in a very unreliable
      fashion, over the wall where he had seen the Caretaker tap it from a
      hiding spot in the closet when he began to feel the wisps of magic again.
    </p>
    <p>
      They seemed to bend and fluctuate to the motions of his wand and he
      focused the transient sensation instantly, seizing his chance before it
      disappeared. There was a strand of it that seemed particle responsive and
      Myles moved his wand directly over it and tapped on the wall while he
      instinctively pulled on it through his wand.
    </p>
    <p>
      The wall before him folded onto itself, collapsing to reveal a well-lit
      yet dirty alley before him. He stepped through in a daze to realize that
      the alley wasn&#39;t lit and it was heavily shaded from the daylight
      above. Stepping from night to day somehow felt even odder than the neatly
      collapsing wall.
    </p>
    <p>
      He walked through the alley with a great deal of excitement and wonder,
      tempered but not beaten by fear and apprehension. The end of it lead to a
      street filled with foreboding and intimidating shops, some with solidly if
      not pleasantly constructed buildings and others made in imitation of a
      rundown shack. A small number of pedestrians walked the streets, none of
      whom seemed particularly nice or clean. They gave him odd, unnerving looks
      as they passed him but he had. He saw a street sign that named this place
      &quot;Knockturn Alley.&quot;
    </p>
    <p>
      Myles hadn&#39;t thought much about what would happen if he got past the
      wall. That obstacle in his path had taken up all of his attention and now
      that he was past it he had only one goal - to find Livian - and no idea
      how to accomplish it. Livian and him had managed to work small bits of
      magic using their blood and Myles had gotten even further than that with
      his wand, but he had only ever worked with material things: lifting small
      objects, unlocking doors, or one time coloring their hair purple. Using
      magic to find someone was abstract and immaterial; Myles wouldn&#39;t even
      know how to start. He needed
    </p>
    <p>
      Myles walked down the street, doing his best to avoid attention when a
      girl his age exited the shop in front of him. She seemed to belong on the
      street even less than he did, at least his old worn black robes fit in
      with the clothing that most of the wizards walking down this alley. The
      girl, who looked to be his age, wore bright and clean violet robes that
      matched her eyes and pure white hair. She should have stood out like a
      store thumb amongst the dark,dreary, and dangerous walking through the
      alley yet no one so much as glanced at her.
    </p>
    <p>
      Her eyes caught his as she stepped out of the shop, a place that managed
      to be both foreboding and alluring with its darkly lit interior and odd
      assortment of displayed items. &quot;Borgin &amp; Burkes&quot; was
      engraved above the door and it didn&#39;t look like a shop for eleven year
      olds. He found the girl and her presence here curious, but it didn&#39;t
      have anything to do with him and he quickly looked away, putting his eyes
      to the ground and waiting for her to look away and ignore him. Myles
      didn&#39;t know what kind of trouble he would get into if people found out
      he had escaped the Orphanage but he&#39;d rather not find out.
    </p>
    <p>
      It did not work. She strode directly over to him so that he was forced to
      stop and look back up at her. His eyes caught at the starkness of her
      violet eyes, white hair, and pale skin. He stepped back as she came
      uncomfortably close, sticking her face just inches from his and looking
      all over his head as if she was looking for something.
    </p>
    <p>
      &quot;Are you the Muren boy?&quot; she asked, finally stepping back to a
      respectable and mostly comfortable distance. Myles nodded; he had no idea
      who the Muren boy was but he hoped that she would just take his answer and
      leave.
    </p>
    <p>
      &quot;Cecilia,&quot; she said, holding out her hand to shake.
      &quot;Cecilia Lovegood-Eden.&quot; Myles shook her hand and, without
      knowing why, gave his own name in return. She smiled back at him in
      response, though he still found the way her searching eyes looked at him
      disconcerting.
    </p>
    <p>
      You&#39;re here to get your stuff for Hogwarts then. I&#39;m about to go
      buy my wand, are you here alone?&quot; she asked.
    </p>
    <p>
      Myles nodded again, hoping it would suffice. He had heard of Hogwarts,
      mentioned in one of the few texts they had in their library (which was
      more of a bookshelf), and knew it was the biggest wizarding school in
      Britain. He supposed this girl either attended the school or was going to
      attend in the near future. He wondered what it would be like, learning
      magic under the tutelage of professors with hundreds of other children.
    </p>
    <p>
      &quot;Well, come along then. Let&#39;s get back to Diagon Alley.&quot;
      Cecilia said, tugging his arm and dragging him along with her. Myles
      hadn&#39;t intended on meeting people so soon after figuring out the exit
      to the Orphanage, but he truly hadn&#39;t planned much of anything past
      that wall; he hadn&#39;t even known where it would take him. He supposed
      Cecilia didn&#39;t seem too dangerous, even if she was a very suspicious
      girl. He had heard of Hogwarts from passing mentions in the Orphanage
      books, but he had never heard of Diagon Alley where Cecilia was taking
      him.
    </p>
    <p>
      &quot;I can&#39;t wait to get my wand, the only thing my Father lets me
      practice with is this cheap and impotent ash and willow and, of course,
      underage magic laws mean I can&#39;t cast just anywhere.&quot; Cecilia
      said, showing her wand. Myles nodding along nearly clueless. He understood
      that ash and willow wands were weak, oddly enough there had been a wand
      making book on the Library bookshelf, but had no idea what the underage
      magic laws were.
    </p>
    <p>
      &quot;Do you have a wand already?&quot; she asked and Myles actually
      responded with more than a nod this time, pulling out his homemade wand
      with no small amount of pride. It wasn&#39;t pretty, he had to admit, but
      it had gotten the job done.
    </p>
    <p>
      &quot;That thing?&quot; Cecilia commented incredulously. &quot;It&#39;s
      more of a wood splinter than a wand.&quot; Embarrassed, and a little hurt
      (more than he had any right to be), he moved to put his wand away but she
      grabbed his arm to stop him and leaned in to get a closer look at the
      wand.
    </p>
    <p>
      &quot;Wait,&quot; she said, her expression changing to one of interest,
      not dissimilar from the one she had had when she had inspected him from
      uncomfortably close when they met each other a few minutes ago. &quot;Did
      you make this yourself?&quot;
    </p>
    <p>
      Myles nodded, his face still a little red, and, realizing he still
      hadn&#39;t said a word in conversation, replied. &quot;Yeah.&quot;
    </p>
    <p>
      &quot;That&#39;s amazing,&quot; Cecilia said earnestly. &quot;But you
      can&#39;t use a wand like this at school, aren&#39;t you going to buy one
      today? They say it&#39;s the most important thing you&#39;ll buy in your
      whole life.&quot;
    </p>
    <p>
      Myles didn&#39;t know much about money, but he was aware enough of the
      concept to realize he had none. &quot;I don&#39;t have any money.&quot;
    </p>
    <p>
      That seemed to make Cecilia pause for the first time since he had met her,
      but then her eyes and the edge of her lips lit with mischief and she
      replied. &quot;I&#39;ll help you then, just follow my lead.&quot;
    </p>
    <p>
      Myles became immediately worried when Cecilia pulled a small knife out of
      her robes and only slightly less so when she nicked her own finger and put
      it away. &quot;What are you doing?&quot;
    </p>
    <p>
      &quot;Don&#39;t worry about it,&quot; she said. &quot;Just smile and
      nod.&quot;
    </p>
    <p>
      Myles began to wonder what he had gotten himself into by unlocking the
      wall and running into this girl, but the street turned and all of his
      attention was taken away. The alley Cecilia and him had been walking down
      had been getting more and more open as well as less shoddy but the street
      it opened into was breathtaking.
    </p>
    <p>
      Brightly colored stores and wares lined the street, signs flashing and
      props performing a number of antics in order to draw attention. He saw a
      monkey dancing from a platform at a pet store labeled &quot;Familiar
      Compendium&quot;, a child sized doll riding a broom back and forth in
      front of &quot;Rodley&#39;s Quidditch Essentials&quot;, and a giant glass
      cauldron at display at &quot;Power of Potions&quot; that was a bubbling
      rainbow of ever changing colors. The wizards themselves that crowded the
      streets, more than Myles had ever really imagined in one place, were
      dressed in a variety of colors and styles. Some wore oddities such as
      talking hats on their heads or familiars on their shoulders, one woman he
      noticed wearing neon pink was going so far as to walk on magic stilts that
      made her four feet taller. Cecilia didn&#39;t look at the wonders before
      her, instead choosing to look at Myles slack jawed expression.
    </p>
    <p>
      &quot;Welcome,&quot; she said with a dramatic flourish. &quot;To Diagon
      Alley.&quot;
    </p>
    <p>
      Her introduction to the major hub of the wizarding community in Britain
      was made less dramatic by breaking down giggling immediately after she had
      made it. &quot;Have you really never been here before? You should see your
      face.&quot;
    </p>
    <p>
      Myles face tinged red again as he remembered to close his mouth but he
      couldn&#39;t bring himself to care much with the sights before him. His
      unashamed staring was broken by Cecilia pulling him forward once again.
    </p>
    <p>
      &quot;C&#39;mon, we have to go. My Father might be looking for me
      already.&quot; Myles, overwhelmed by the spectacle around him, let Cecilia
      drag him through the crowd. They stopped in front of a pet store just as a
      pale man who looked a bit like Cecilia and wore finely made and tailored
      robes arrived.
    </p>
    <p>
      Cecilia&#39;s demeanor changed completely as the man caught sight of them,
      changing into a girl nearly unrecognizable from the one he had met in
      Knockturn Alley. &quot;Daddy!&quot; she exclaimed, pulling Myles along
      with her until she was close enough to embrace her father.
    </p>
    <p>
      &quot;You should have... I got.. It was scary…&quot; she said in a
      breathless rush that continued too fast to be understood. Myles caught the
      words &quot;attacked&quot;, &quot;saved&quot;, and &quot;friend&quot; from
      it but little else.
    </p>
    <p>
      &quot;Slow down darling, take a deep breath.&quot; the man said in soft
      tones, crouching down to speak with his daughter. He waited a moment for
      Cecilia to calm herself. &quot;Now tell me, what happened?&quot;
    </p>
    <p>
      Myles was amazed at her acting ability. With wide guileless eyes she
      explained how she took a wrong turn into a &quot;very scary alley&quot;
      where she was attacked by a wizard.
    </p>
    <p>
      &quot;Cecilia dear, are you sure he wasn&#39;t trying to sell you
      something? A lot of bad dealers sell things in alleys like that.&quot;
      Cecilia&#39;s father replied patiently.
    </p>
    <p>
      &quot;Oh.&quot; Ceclia said, her eyes downcast in a perfect picture of
      innocent embarrassment. &quot;Maybe. I don&#39;t know. I was so
      scared.&quot;
    </p>
    <p>
      She lifted her eyes back to her father&#39;s as excitement edged back into
      her voice. &quot;But Daddy, Myles here saw me in trouble and ran right to
      save me, like a real hero and I was so grateful I offered him a life
      debt…&quot;
    </p>
    <p>
      &quot;YOU WHAT?&quot; Cecilia&#39;s father exclaimed, cutting off his
      daughter. &quot;Don&#39;t tell me you swore the oath.&quot;
    </p>
    <p>
      Cecilia seemed to wilter before her father. &quot;Daddy… I thought it was
      proper, I swore it on blood.&quot; She held up the finger she had cut
      earlier.
    </p>
    <p>
      Her father put his head down and massaged his temples, clearly perplexed
      with his daughter and the situation she had gotten herself into. When he
      rose his expression was calm and controlled and he stepped towards Myles,
      resting one hand on his daughter&#39;s back and holding out his other hand
      to Myles.
    </p>
    <p>
      &quot;Tenan Eden.&quot; Myles shook the offered hand, giving only his
      first name in return (he didn&#39;t have a last name to give in the first
      place).
    </p>
    <p>
      &quot;What do you request in fulfillment for the life oath?&quot;
      Cecilia&#39;s father, Mr. Eden, asked Myles formally, a distrustful and
      disparaging (Myles robes weren&#39;t new or nice)
    </p>
    <p>
      &quot;Oh Daddy, I said we could buy him a wand, he needs a new one for
      Hogwarts and we&#39;re going there now anyways!&quot; Cecilia interjected,
      saving Myles from having to answer.
    </p>
    <p>
      &quot;Will that suffice as repayment?&quot; Mr. Eden asked Myles, looking
      a bit relieved.
    </p>
    <p>
      &quot;Yes it will.&quot; Myles replied, feeling like he was required to do
      more than nod his assent.
    </p>
    <p>
      &quot;Then it is done.&quot; the man said, pulling out a slit of paper
      from his robes and pressing his wand to it before handing it to Cecilia.
    </p>
    <p>
      &quot;I&#39;ll walk you two to Olivander&#39;s while I go on my last
      errand. You will stay there. You will not leave until I come back to get
      you. Do you understand?&quot; Mr. Eden said, looking directly at his
      daughter and handing her the slip of paper he had just enchanted.
    </p>
    <p>Cecilia nodded earnestly. &quot;Yes, daddy.&quot;</p>
    <p>
      Olivanders did not look as impressive or showy as many of the shops he had
      seen in Diagon Alley but there was a weight to it that the others
      didn&#39;t. Something about the place felt important. The well dressed but
      slightly disheveled middle-aged man Myles saw through the window backed
      that impression, stating that the man had better things to do than tidy
      his hair and clothes.
    </p>
    <p>
      &quot;Behave yourself and wait for me to come pick you.&quot; Mr. Eden
      said to Cecilia before shooting Myles a distrustful glance and striding
      away.
    </p>
    <p>
      Cecilia laughed once he had left. &quot;What did you think? Should I go
      into acting?&quot;
    </p>
    <p>
      &quot;You were amazing.&quot; Myles said honestly. &quot;But why go
      through all of that? You really don&#39;t have to buy me a wand.&quot;
    </p>
    <p>
      &quot;A girl&#39;s gotta have her fun somehow.&quot; Cecilia pouted.
      &quot;We&#39;re rich anyways, my mom improved the Floo system and my dad
      got a patent for it. Now money just comes in.&quot;
    </p>
    <p>
      Myles knew a &#39;Floo system&#39; was some sort of travel but he had no
      idea what a patent was. He decided to ask about the piece of paper
      Cecilia&#39;s father had handed her instead though.
    </p>
    <p>
      &quot;Oh, it&#39;s a check. You enchant it with your signature and the
      intended recipient, and the color enacts a galleon limit on the
      purchase.&quot; she said, holding it up so Myles could see her
      father&#39;s signature and line &quot;Ollivander&#39;s Wand Shop&quot;
      that designated the recipient, as well as the blank line where the money
      amount went and the Gringotts watermark behind it all.
    </p>
    <p>
      They entered the shop then, where the man inspecting a wand at his desk
      greeted them.
    </p>
    <p>
      &quot;Welcome to Ollivander&#39;s. Buying wands today?&quot; Cecilia and
      Myles nodded. &quot;Who&#39;s first?&quot;
    </p>
    <p>
      &quot;He is.&quot; Cecilia said instantly and the man, Mr. Ollivander,
      turned to inspect Myles. His eyes were piercing and their gaze
      uncomfortable, as if they were looking under his skin and seeing something
      even Myles didn&#39;t know was there. It was, he realized, almost the same
      as the way Cecilia had looked at him when they met.
    </p>
    <p>
      Mr. Ollivander simply stared at him for several long moments before
      turning to the wall (which, like every upright surface in the store, was
      covered by stacks of rectangular boxes) to his side and climbing up a
      ladder that moved on its own to where the man intended to go. He pulled
      down a box and opened it, revealing the wand inside.
    </p>
    <p>
      &quot;Ebony, twelve and a quarter inches, dragon heartstring.&quot; he
      stated, handing it to Myles.
    </p>
    <p>
      The floor shook as soon as his fingers touched the wood and he dropped it
      in startlement. Mr. Ollivander caught it before it fell to the ground and
      placed it back into its box with a detached and unsurprised remark.
      &quot;Not quite.&quot;
    </p>
    <p>
      This began a long and arduous process of breaking household items, fire,
      uncomfortably loud noises and bright lights all rooting from the ends of
      the wands Mr. Ollivander handed him. Some wands required a wave and others
      would cause something to combust by simply touching them. It was not a
      particularly comfortable process, each wand he touched gave his hand a
      shock, a couple of them even locking his fingers. Cecilia, however, had
      made herself comfortable sitting cross legged on the floor in the corner
      of the shop and seemed to be enjoying watching his repeated failures
      immensely, her watchful eyes serving only to make the situation even more
      uncomfortable.
    </p>
    <p>
      Mr. Ollivander did not seem to mind the repeated failures. In fact, he
      simply became more and more interested and invested, containing the more
      explosive interactions between Myles and the wands with a wave of his own.
      After almost thirty wands the process slowed considerably, with Mr.
      Ollivander traveling further back into the shop and taking longer to
      return each time. The results however, proved no different and the
      man&#39;s eyes took on an obsessive glint.
    </p>
    <p>
      &quot;I&#39;ll have to see what my father thinks.&quot; he said, before
      heading into the back of the shop and returning a few minutes later with a
      much older, slower and wizened Mr. Ollivander. Myles was asked to hold
      some of the failed wands again, and then the two Ollivander&#39;s
      disappeared into the back of the store, conferring quietly with each
      other.
    </p>
    <p>&quot;Is it always like this?&quot; Myles asked.</p>
    <p>
      &quot;No.&quot; Cecilia replied, looking inordinately pleased with
      herself. &#39;They&#39;re all bloody insane,&#39; Myles thought, tiring of
      being examined by both the Ollivanders and Cecilia. He really hoped the
      next wand they came out with worked. They returned however, not with
      another wand case, but levitating a large black chest in front of them.
    </p>
    <p>
      &quot;We have a number of… more unusual wands here, but understand some of
      them are pricier choices.&quot; the younger Ollivander stated, setting
      down and opening the chest.
    </p>
    <p>
      &quot;That&#39;s fine.&quot; Cecilia said from she sat in the corner, and
      Ollivander nodded and they proceed their wand testing.
    </p>
    <p>
      Acacia, ienian spider silk sac, fourteen and a half inches.
      &quot;Certainly not.&quot;
    </p>
    <p>
      Snakewood, serpent horn, thirteen and three quarter inches. &quot;Hmmm…
      perhaps.&quot;
    </p>
    <p>Elm, thestral tailhair, twelve inches even. &quot;No.&quot;</p>
    <p>
      Blackthorn, chimera tail, ten and a half inches. &quot;Not quite.&quot;
    </p>
    <p>
      Walnut, sphinx brain cord, eleven and a quarter inches. &quot;Not a match,
      questionable legality in any case.&quot;
    </p>
    <p>
      Yew, unknown core, rumored to be the remnants of a dementor, thirteen and
      a quarter inches. This created an unearthly and haunting wail that left
      everyone reeling. &quot;Definitely... definitely not.&quot;
    </p>
    <p>
      The older Ollivander got a curious look on his face and reached deep into
      the chest, pulling out an old and simple wooden case. The younger
      Ollivander looked doubtful. &quot;Father, there is no evidence that that
      wand even works.&quot;
    </p>
    <p>
      &quot;Nevertheless, no harm in trying,&quot; the older Ollivander said,
      opening the box to reveal the wand. &quot;Married elder and yew, dual core
      of dragon heartstring of the extinct Lethian Occiden and an unknown
      substance, thirteen inches even.&quot;
    </p>
    <p>
      Myles remembered from the wand making book in the Orphanage that only
      single core wands were functional, and it had never even mentioned wands
      made with multiple woods but he held out his hand to accept it. The wand
      was not split in half by its composite woods but rather made up of tightly
      woven spirals of the two woods, each sliver of the same wood so narrow
      that the wand didn&#39;t look to be made of different woods until seeing
      it up close.
    </p>
    <p>
      As Myles fingers closed around the wand two chords sounded, as if from a
      piano yet strange and undefinable, from the wand&#39;s tip. They resonated
      deeply in the shop&#39;s wooden structure and held themselves distinct and
      separate. The first chord was louder and more powerful, low pitched and
      temperamental, nearly a growl in its tone. The second was not as loud but
      it felt more important somehow, depths of subtleties running in the
      fluctuations of its timbre.
    </p>
    <p>
      The wand only made the noise for a couple of seconds, but the sound clung
      to the air and walls for long moments after the wand stopped, echoing
      lightly throughout the shop. The Ollivanders stared with unadulterated
      interest at Myles and the wand.
    </p>
    <p>&quot;A fine match indeed, Mr…?&quot; the senior Ollivander probed.</p>
    <p>
      &quot;Myles.&quot; Myles replied, awkwardly answering with only his first
      name for the third time today.
    </p>
    <p>
      &quot;The last thought to wield that wand died nearly a millennium ago,
      before even the Interdict of Merlin. It may not be the wand of legend that
      the Elder wand is, but it may be even trickier to find a wizard it will
      allow to yield it. Most wandmakers think this twined wand is nothing more
      than a failed and erratic experiment.&quot; the senior Ollivander said.
    </p>
    <p>
      Myles had no response to that and was relieved when Cecilia interjected.
      &quot;Can I try that wand?&quot; she asked, pointing to one of the cases
      in the pile of wands Myles had tried.
    </p>
    <p>
      &quot;Certainly,&quot; the younger Ollivander said, holding an expression
      that said he was going to indulge the clueless girl&#39;s request but that
      he had better things to do with his time. &quot;It&#39;s one of the
      trickier wands though, few bond well with Acacia and even fewer, rumor
      says, bond with ienian silk sac.&quot;
    </p>
    <p>
      &quot;Acacia, ienian spider silk sac, thirteen and a half inches.&quot; he
      stated as he held out the wand, acting as if he hadn&#39;t just described
      the wand.
    </p>
    <p>
      Cecilia took the wand, which looked almost rid with confidence and waved
      it imperiously to let loose a rainbow of color that chimed neatly as it
      transitioned from purple to blue to green to yellow and so on. She gave
      Myles a wink and looked rather pleased with herself as she observed the
      shocked looks on the Ollivander&#39;s faces.
    </p>
    <p>
      &quot;Most impressive Ms. Eden. I hope you&#39;ll consider an internship
      offer for next summer.&quot; the younger Ollivander said when he had
      recovered.
    </p>
    <p>
      &quot;I&#39;ll ask my Father about it.&quot; Cecilia replied, pulling out
      the piece of paper her father had given her. &quot;How much will the wands
      cost?&quot;
    </p>
    <p>
      &quot;I&#39;m afraid I can&#39;t let the Twined wand go for less than
      twenty-five galleons, other wizards might not be able to use it but
      it&#39;s worth at least that much as an oddity. The acacia and ienian silk
      sac wand is also a rarity, but tricky enough that I can get rid of it for
      only twelve galleons.&quot; the younger Ollivander said. Cecilia returned
      to her act from earlier, her demeanor growing years younger in seconds.
    </p>
    <p>
      &quot;Oh,&quot; she said sadly. &quot;My father&#39;s check only goes up
      to thirty galleons. I..&quot;
    </p>
    <p>
      Myles thought the act was rather obvious, but apparently the wide puppy
      eyes, artistically trailed off sentence, and nervous fingers tugging at
      the edged of her robes worked wonders on the Ollivanders.
    </p>
    <p>
      &quot;Well,&quot; the junior Ollivander said. &quot;If the two of you were
      willing to add a visit over Christmas break into the bargain we could make
      that work.&quot;
    </p>
    <p>
      &quot;Really!?&quot; Cecilia beamed. &quot;We&#39;d love to visit!&quot;
    </p>
    <p>
      Myles nodded along in agreement with Cecilia&#39;s enthusiastic reply,
      though he had no idea where he would be come Christmas time. She gave the
      Ollivanders her check and they exited the store with farewells.
    </p>
    <p>
      &quot;My father will be here soon if you want to wait with me. We&#39;ll
      only be going back home though, I already have my other school
      supplies.&quot; Cecilia said.
    </p>
    <p>
      &quot;I&#39;ll wait.&quot; Myles said, running his fingers over the wood
      of his new wand again and again, engaging himself in trying to feel out
      the extremely subtle changes in wood. &quot;And Cecilia… thank you.&quot;
    </p>
    <p>
      &quot;Don&#39;t mention it.&quot; Cecilia smiled. &quot;It was fun.&quot;
    </p>
    <p>
      Myles realized he was dreading Cecilia&#39;s father&#39;s arrival. He
      hadn&#39;t had a friend since Livian had been taken from the Orphanage
      years ago and while he might find her knowing smiles (often more smirk
      than smile) and inspecting eyes a bit annoying, there was something
      captivating about Cecilia. The way she walked naturally through unfriendly
      alleys without drawing a glance, the way she introduced herself to a
      complete stranger and dragged him off to buy him a wand, the way she
      changed into a sweet wide-eyed girl when she wanted something from an
      adult.
    </p>
    <p>
      &quot;There he is.&quot; Cecilia said, spotting her father in the traffic.
      She rushed Miles and gave him a quick hug that he awkwardly returned.
      &quot;Here&#39;s my address, don&#39;t hesitate to visit or owl. I&#39;ll
      see you at Hogwarts.&quot;
    </p>
    <p>
      She flashed him a smile and handed him a slip of parchment before going to
      greet her father and Myles was alone once again. He slipped the paper next
      to his two wands in his pocket and a wave of exhaustion ran over him. It
      may be daytime here, but he had stayed up the whole night at the Orphanage
      before opening the wall.
    </p>
    <p>
      Myles walked down Diagon Alley, taking in all of the colors, noise, and
      wares on display and hoping to find a place to sleep. His thoughts were
      drawn to how different Cecilia and Livian were.
    </p>
    <p>
      Livian&#39;s eyes had always been unfocused, rarely making eye contact and
      giving off the impression she was never paying attention while Cecilia
      viewed everything that interested her through a magnifying glass.
    </p>
    <p>
      Cecilia was well-dressed and presented, with her hair neatly arranged
      under a purple ribbon, neatly cared for nails, and wearing a couple pieces
      of jewelry. Livian had never done more than the minimum to keep up with
      hygiene at the Orphanage, much less care for her appearance. Her hair had
      been frayed and wild and she had managed to steal some of the older boys
      clothes before they graduated so she wore overly large and baggy clothes.
    </p>
    <p>
      It was more than how they dressed however, Myles wouldn&#39;t call
      Cecilia&#39;s demeanor uptight but there was a sense of control about the
      way she presented herself, like she wouldn&#39;t let you see any more or
      less of herself than she wanted you to. Livian had always been relaxed,
      she didn&#39;t sit so much as lounge and she truly didn&#39;t care what
      others thought of her, she was content peacefully reading a book, laying
      upside down on a couch in the library while other kids made jokes at her
      expense.
    </p>
    <p>
      For all their differences however, Myles thought the two girls were
      similar in some intangible fashion. Perhaps it was the way you could never
      really tell what was going on in their heads, or perhaps it was the way
      they decided on a goal and single mindedly chased it. Cecilia had decided
      that she was going to get Myles a wand and followed through without
      hesitating. It reminded him of Livian&#39;s determination to unlock the
      Caretaker&#39;s door to see how she came and went from the Orphanage.
    </p>
    <p>
      Myles found the street quickly becoming deserted as he walked onwards. The
      display of bright and boisterous wares faded to for sale signs and
      deserted stores. The few shops that remained open this far down the Alley
      had fallen on hard times and scarce customers.
    </p>
    <p>
      Myles, stifling a yawn, spotted an old shop that looked like it hadn&#39;t
      been touched in years and made his way towards it. He glanced around
      quickly to make sure no one was looking and approached the door. Myles
      pulled out his new wand and placed it&#39;s tip against the door. His old
      wand had been finicky when it came to unlocking doors (or doing any sort
      of magic really), but the lock clicked open neatly and he opened the door.
    </p>
    <p>
      He stepped in the dusty and deserted shop, hoping that no one had bothered
      warding the entryway. It wasn&#39;t comfortable but he managed to find a
      tarp in the back and clump it into a pillow. Myles thought for a second
      about how little he knew about his situation - Were people looking for him
      for escaping the Orphanage? What was he going to eat? How would he learn
      magic to help him find Livian? Could he trust anyone? Could he trust
      Cecilia - and a thousand other questions before he laid his head down and
      immediately fell asleep.
    </p>
    <hr />
    <p>
      Excerpt from &quot;Magical Abilities: From Anamagi to Zyntralists&quot; by
      Goren Beesot:
    </p>
    <p>
      <em>
        &quot;Magic Sight, named primarily for its poetic sound as it typically
        does not coalesce itself visually, is a sixth sense for magic
        experienced magic users develop by testing subtle resonates between
        their magical cores and ambient magic. Even the most well constructed
        spells leak magic, and a wizard with well developed magical sight can
        sense the &quot;shape&quot; or construction of the cast spell.
      </em>
    </p>
    <p>
      <em>
        Most wizards never develop a sensitive magical sight as daily routines,
        rote magic, and normal locations do little for its development. Life and
        death (or similarly high pressure scenarios) involving magic, performing
        or close proximity to experimental and/or high powered magics, and
        places of great magical power can greatly accelerate the development of
        magical sight (e.g Hogwarts of the Department of Mysteries). For these
        reasons Aurors, talented professors, and particularly Unspeakables tend
        to have very well developed Magic Sight.
      </em>
    </p>
    <p>
      <em>
        Rare and extremely talented wizards have been known to acquire early
        Magic Sight at a young age. Generational talent such as Albus
        Dumbledore, Baba Yaga, and Grindelwald all had notable skill in the
        field by only their third year.&quot;
      </em>
    </p>
  </div>
);

export default one;
